module.exports = __webpack_public_path__ + "img/sweat.33d30a94.svg";